import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from './components/layout/layout.component';
import { SharedRoutingModule } from './shared-routing.module';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FooterComponent } from './components/footer/footer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { LoaderTextPipe } from './pipes/loader-text.pipe';
import { TranslateBackendMsgPipe } from './pipes/translate-backend-msg.pipe';

@NgModule({
  declarations: [
    HeaderComponent,
    LayoutComponent,
    SidebarComponent,
    FooterComponent,
    AlertDialogComponent,
    LoaderTextPipe,
    TranslateBackendMsgPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedRoutingModule,
    NgbModule
  ],
  exports: [
    HeaderComponent,
    LayoutComponent,
    SidebarComponent,
    FooterComponent,
    AlertDialogComponent,
    LoaderTextPipe,
    TranslateBackendMsgPipe,
  ]
})
export class SharedModule { }
